import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <img
                src="https://img1.wsimg.com/isteam/ip/ef6b4008-7081-4736-a8f7-eb15cb13938a/1000014942.jpg/:/rs=h:200,cg:true,m/qt=q:95"
                alt="Knight In Shining Armor Heating & Air — KISA Cooling Dallas"
                className="h-14 w-auto object-contain"
              />
            </Link>
            <p className="font-['Inter'] text-gray-500 text-sm leading-relaxed mb-6">
              Precision HVAC cooling solutions for Dallas homes and businesses. Licensed, insured, and performance-driven.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="tel:2148703185"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:text-[#0EA5E9] hover:border-[#0EA5E9] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-phone-line text-sm"></i>
              </a>
              <a
                href="mailto:pruitt@kisacoolingdallas.com"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:text-[#0EA5E9] hover:border-[#0EA5E9] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-mail-line text-sm"></i>
              </a>
              <a
                href="https://www.facebook.com/1627962247475385"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:text-[#0EA5E9] hover:border-[#0EA5E9] transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-['Inter'] text-gray-900 font-semibold text-sm uppercase tracking-widest mb-5">
              <a id="services-footer-nav">Services</a>
            </h4>
            <ul className="space-y-3">
              {[
                "AC Repair",
                "AC Installation & Replacement",
                "Preventative Maintenance",
                "Emergency HVAC Service",
                "Air Duct Cleaning",
                "Furnace Repair & Heating",
              ].map((item) => (
                <li key={item}>
                  <Link
                    to="/services"
                    className="font-['Inter'] text-gray-500 text-sm hover:text-[#0EA5E9] transition-colors duration-300"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-['Inter'] text-gray-900 font-semibold text-sm uppercase tracking-widest mb-5">
              <a id="company-footer-nav">Company</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Home", href: "/" },
                { label: "About Us", href: "/about" },
                { label: "Service Areas", href: "/location-dallas" },
                { label: "Get a Quote", href: "/#quote" },
              ].map((item) => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="font-['Inter'] text-gray-500 text-sm hover:text-[#0EA5E9] transition-colors duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-['Inter'] text-gray-900 font-semibold text-sm uppercase tracking-widest mb-5">
              <a id="contact-footer-nav">Contact</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-[#0EA5E9] text-sm"></i>
                </div>
                <a
                  href="tel:2148703185"
                  className="font-['Inter'] text-gray-600 text-sm hover:text-[#0EA5E9] transition-colors duration-300 font-medium"
                >
                  214-870-3185
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-[#0EA5E9] text-sm"></i>
                </div>
                <a
                  href="mailto:pruitt@kisacoolingdallas.com"
                  className="font-['Inter'] text-gray-600 text-sm hover:text-[#0EA5E9] transition-colors duration-300 break-all"
                >
                  pruitt@kisacoolingdallas.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[#0EA5E9] text-sm"></i>
                </div>
                <address className="font-['Inter'] text-gray-600 text-sm not-italic leading-relaxed">
                  833 Inwood Dr<br />McKinney, TX 75069
                </address>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-100 px-6 py-5 bg-gray-50">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-['Inter'] text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} Knight In Shining Armor Heating &amp; Air (KISA). All rights reserved. Licensed &amp; Insured — Serving Dallas, TX &amp; Surrounding Areas.
          </p>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
            <span className="font-['Inter'] text-gray-400 text-xs">Same-Day Service Available</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
